import { delegatepage } from "./states";

export const services = {
  delegatepage,
};
